export var UPDATE_CART_ITEM_EDITOR = 'UPDATE_CART_ITEM_EDITOR';
export var UPDATE_SELECTED_PHOTO = 'UPDATE_SELECTED_PHOTO';
export var UPDATE_SELECTED_PRODUCT_ITEM = 'UPDATE_SELECTED_PRODUCT_ITEM';
export var UPDATE_PHOTO_PRODUCT_ITEM = 'UPDATE_PHOTO_PRODUCT_ITEM';
export var UPLOAD_PHOTOS_REQUEST = 'UPLOAD_PHOTOS_REQUEST';
export var UPLOAD_PHOTOS_SUCCESS = 'UPLOAD_PHOTOS_SUCCESS';
export var UPLOAD_PHOTOS_ERROR = 'UPLOAD_PHOTOS_ERROR';
export var UPDATE_PHOTO_UPLOAD_PROCESS = 'UPDATE_PHOTO_UPLOAD_PROCESS';
